var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row-space" },
    [
      _vm._t("header", function () {
        return [
          _c(
            "div",
            { staticClass: "search-preference__title" },
            [
              _vm._t("label", function () {
                return [
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
                ]
              }),
            ],
            2
          ),
        ]
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }